import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=79b8a9c4&"
import script from "./distributor.vue?vue&type=script&lang=js&"
export * from "./distributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports